import {ActivatedRouteSnapshot, CanActivateFn, UrlSegment, UrlSegmentGroup, UrlTree} from '@angular/router';

export const hasMissingDataNonce: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  if (
    route.url.find(el => el.path === 'missing-data') &&
    route.params['jobId'] &&
    route.params['applicationId'] &&
    route.queryParams['nonce']
  ) {
    const nonceMap: {
      [key: number]: {
        nonce: string;
        application: number;
        trigger?: string;
      };
    } = JSON.parse(sessionStorage.getItem('missing-data-nonces')) ?? {};

    nonceMap[+route.params['jobId']] = {nonce: route.queryParams['nonce'], application: +route.params['applicationId']};
    if (route.url.findIndex(el => el.path === 'missing-data') !== route.url.length - 1) {
      nonceMap[+route.params['jobId']].trigger = route.url[route.url.length - 1].path;
    }
    sessionStorage.setItem('missing-data-nonces', JSON.stringify(nonceMap));
    return true;
  }
  if (route.url.find(el => el.path === 'apply') && route.params['jobId']) {
    const nonceMap: {
      [key: number]: {
        nonce: string;
        application: number;
        trigger?: string;
      };
    } = JSON.parse(sessionStorage.getItem('missing-data-nonces')) ?? {};
    if (!nonceMap[+route.params['jobId']]) return true;

    const urlSegments = [
      new UrlSegment('applications', {}),
      new UrlSegment(nonceMap[+route.params['jobId']].application + '', {}),
      new UrlSegment('missing-data', {}),
    ];
    if (nonceMap[+route.params['jobId']].trigger)
      urlSegments.push(new UrlSegment(nonceMap[+route.params['jobId']].trigger, {}));

    return new UrlTree(
      new UrlSegmentGroup([], {
        primary: new UrlSegmentGroup(
          [
            ...route.url.slice(
              0,
              route.url.findIndex(el => el.path === 'apply')
            ),
            ...urlSegments,
          ],
          {}
        ),
      }),
      {nonce: nonceMap[+route.params['jobId']].nonce}
    );
  }
  return true;
};
